import futura from '../assets/futura.png'
import { useState, useEffect, useRef } from 'react';
import Select from 'react-select'
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
const N1 = ({ bookid, nextPage, profid, previuosPage, home }) => {
    const [cookieRes, setCookieRes] = useState();
    const [professioni, setProfessioni] = useState([])
    const [trattamento, setTrattamento] = useState([])
    const [tutto, setTutto] = useState({})
    const [check1, setc1] = useState(false)
    const [check2, setc2] = useState(false)
    const [sel1, setSel1] = useState(profid)
    const [sel2, setSel2] = useState(null)
    const select2 = useRef();

    const getProf = () => {
        fetch(document.apiURL + '/prof', {
            method: 'GET',

            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setProfessioni(response.map(r => { return { "value": r.id, "label": r.prof_label } }))

            });
    }

    const editBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'PUT',
            cache: 'no-cache',

            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "profID": sel1,
                "treatID": sel2,
                " medical_prescr": check1
            })
        })
            .then(response => response.json())
            .then(response => {
                nextPage()
            });
    }

    const getTrattamenti = (id) => {
        select2.current.clearValue()
        setTrattamento(tutto.map(t => t.prof.id == id ? { "label": t.treatment, "value": t.id } : null).filter(f => f != null))
    }

    const ottieniTutto = () => {
        fetch(document.apiURL + '/treat', {
            method: 'GET',
            cache: 'no-cache',

            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setTutto(response)
            });
    }

    const profPresente = () => {
        if (profid != 0 && Object.keys(tutto).length != 0) { getTrattamenti(profid) }
    }
    const setProf = () => {
        if (sel1 === null)
            setSel1(profid)
    }

    useEffect(() => {
        getProf();
        ottieniTutto();

    }, [profid]);

    useEffect(() => {
        profPresente()
    }, [tutto])

    const dis = () => {
        if (check2 != false && sel2 != null) { return false }
        else { return true }

    }

    return (<>
        <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="square-center">
                <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

                    <img src={arrow} onClick={()=> previuosPage()} /> 
                    <img src={close} onClick={()=> home()} />  

                </div>
                <div className="flex row center-con sp" >

                    <h2 className="c">Di quale servizio hai bisogno?</h2><img src={futura} className="min-fut">
                    </img>

                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Professionista o servizio:</h4>
                        <Select className="react-input-full" value={sel1 === null ? professioni.filter(t => t.value == profid ? t.label : null) : professioni.filter(t => t.value == sel1 ? t.label : null)} onChange={(e) => { getTrattamenti(e.value); setSel1(e.value) }} placeholder={profid === 0 ? professioni.map(t => t.value == profid ? t.label : null) : "Seleziona un professionista o servizio"} options={professioni} />

                        {/* <select className="input" style={{ width: '100%' }} onChange={e => setTrattamento(tutto.filter(t => t.prof.id == e.target.value))} >*/}

                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col " style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Prestazione:</h4>
                        <Select ref={select2} className="react-input-full" onClick={() => { profPresente(); setProf() }} onChange={(e) => e != null && setSel2(e.value)} placeholder={"Seleziona un professionista"} options={trattamento} />

                        <div style={{ marginTop: '20px', width: '100%', display: 'flex' }}><input type="checkbox" onChange={() => setc1(!check1)} checked={check1}></input> <p style={{ fontWeight: 600 }}>Confermo di essere in possesso di una prescrizione medica</p></div>

                        <div style={{ marginTop: '20px', width: '100%', display: 'flex' }}><input type="checkbox" onChange={() => setc2(!check2)} checked={check2}></input> <p style={{ fontWeight: 600 }}>Accetto i <a>Termini e Condizioni</a> del servizio e il trattamento dei dati secondo Privacy Policy.</p></div>

                        <button disabled={dis()} onClick={() => { editBook() }} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                        <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessita puoi contattare un nostro operatore al numero<br /> <a>+39 324324234</a> che ti aiutera nella prenotazione.</p>

                    </div>
                </div>
            </div>

        </div>
    </>
    );
}

export default N1;